var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactor5X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34C26.8366 34 34 26.8366 34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34Z",
    fill: "#F2CD2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 14.5469L13.4219 17.1172L14.8594 14.5469H17.2578L14.8672 18.6797L17.3672 23H14.9609L13.4375 20.2813L11.9141 23H9.5078L12.0078 18.6797L9.6172 14.5469H12.0234ZM20.375 17.8203L18.5781 17.3906L19.2266 11.625H25.6172V13.4453H21.0781L20.7969 15.9688C20.9479 15.8802 21.1771 15.7865 21.4844 15.6875C21.7917 15.5833 22.1354 15.5313 22.5156 15.5313C23.0677 15.5313 23.5573 15.6172 23.9844 15.7891C24.4115 15.9609 24.7734 16.2109 25.0703 16.5391C25.3724 16.8672 25.6016 17.2682 25.7578 17.7422C25.9141 18.2161 25.9922 18.7526 25.9922 19.3516C25.9922 19.8568 25.9141 20.3385 25.7578 20.7969C25.6016 21.25 25.3646 21.6563 25.0469 22.0156C24.7292 22.3698 24.3307 22.6484 23.8516 22.8516C23.3724 23.0547 22.8047 23.1562 22.1484 23.1562C21.6589 23.1562 21.1849 23.0833 20.7266 22.9375C20.2734 22.7917 19.8646 22.5755 19.5 22.2891C19.1406 22.0026 18.8516 21.6563 18.6328 21.25C18.4193 20.8385 18.3073 20.3698 18.2969 19.8438H20.5312C20.5625 20.1667 20.6458 20.4453 20.7812 20.6797C20.9219 20.9089 21.1068 21.0859 21.3359 21.2109C21.5651 21.3359 21.8333 21.3984 22.1406 21.3984C22.4271 21.3984 22.6719 21.3438 22.875 21.2344C23.0781 21.125 23.2422 20.974 23.3672 20.7813C23.4922 20.5833 23.5833 20.3542 23.6406 20.0938C23.7031 19.8281 23.7344 19.5417 23.7344 19.2344C23.7344 18.9271 23.6979 18.6484 23.625 18.3984C23.5521 18.1484 23.4401 17.9323 23.2891 17.75C23.138 17.5677 22.9453 17.4271 22.7109 17.3281C22.4818 17.2292 22.2135 17.1797 21.9062 17.1797C21.4896 17.1797 21.1667 17.2448 20.9375 17.375C20.7135 17.5052 20.526 17.6536 20.375 17.8203Z",
    fill: "#544400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactor5X);
export default __webpack_public_path__ + "static/media/factor5x.3c36a01ea2c97319478651b9fdbf1032.svg";
export { ForwardRef as ReactComponent };